export const CONTACT_EMAIL = 'Intrack.GSCSC@hu.bosch.com';
export const CONTACT_PHONE_NUMBER = '+49(711)811-11777';
export const USER_GUIDE =
  'https://inside-docupedia.bosch.com/confluence/display/InTrackUserManuals/InTrack+User+Manuals';
export const RAISE_TICKET_URL = 'https://gbs.bosch.com/esc?id=sc_cat_item&sys_id=90bc166c1bdd0a143ce132a99b4bcb49';
